import { defineStore } from 'pinia'
import moment from 'moment';

export const useInteresseStore = defineStore('interesse', {
    
  state: () => {
    return {      
      enderecoResponsavelIgualAluno: true,
      Interesse: {
        Midia: null,
        EscolaAnterior: null,
        ContatoEmail: null,
        ContatoTelefone: true,
        Observacoes: '',
        AceiteLgpd: false,
        OpcoesInteresse: {
          Unidade: {
            codigo: 0,
            descricao: ''
          },
          Periodo: {
            codigo: 0,
            descricao: ''
          },
          Curso: {
            codigo: 0,
            descricao: ''
          },
          Serie: {
            codigo: 0,
            descricao: ''
          },
          Turno: {
            codigo: 0,
            descricao: ''
          }
        },
        Responsavel: {
          Nome: '',
          Cpf: null,
          Sexo: null,
          Parentesco: null,
          Email: '',
          Telefone: null,
          EnderecoObrigatorio: false,
          Endereco: {
            Cep: '',
            Logradouro: '',
            Numero: '',
            Complemento: '',
            Bairro: '',
            Cidade: '',
            Estado: ''
          }
        },
        Aluno: {
          Nome: '',
          Cpf: null,
          DataNascimento: '',
          Sexo: null,
          EnderecoObrigatorio: false,
          Endereco: {
            Cep: '',
            Logradouro: '',
            Numero: '',
            Complemento: '',
            Bairro: '',
            Cidade: '',
            Estado: ''
          }
        }
      },
      Autorizado: false
    }
  },
  actions: {
    obterClienteParaEnvio(Cliente) {
      Cliente.nome = this.Interesse.Aluno.Nome;
      Cliente.cpf = this.Interesse.Aluno.Cpf;
      Cliente.sexo = this.Interesse.Aluno.Sexo.codigo;
      Cliente.dataNascimento = moment(moment(this.Interesse.Aluno.DataNascimento, "DD-MM-YYYY")).format("YYYY-MM-DD");
      Cliente.observacao = this.Interesse.Observacoes;      
      Cliente.tipoContato = this.Interesse.ContatoTelefone ? 1 : 2;
      Cliente.cep = this.Interesse.Aluno.Endereco.Cep;
      Cliente.logradouro = this.Interesse.Aluno.Endereco.Logradouro;
      Cliente.numeroLogradouro = this.Interesse.Aluno.Endereco.Numero;
      Cliente.complemento = this.Interesse.Aluno.Endereco.Complemento;
      Cliente.bairro.descricao = this.Interesse.Aluno.Endereco.Bairro;
      Cliente.cidade.descricao = this.Interesse.Aluno.Endereco.Cidade;
      Cliente.uf = this.Interesse.Aluno.Endereco.Estado;

      Cliente.responsavel.nome = this.Interesse.Responsavel.Nome;
      Cliente.responsavel.sexo = this.Interesse.Responsavel.Sexo.codigo;
      Cliente.responsavel.tipoVinculo.codigo = this.Interesse.Responsavel.Parentesco.codigo;
      Cliente.responsavel.tipoVinculo.descricao = this.Interesse.Responsavel.Parentesco.descricao;
      Cliente.responsavel.tipoVinculo.tipoParentesco = this.Interesse.Responsavel.Parentesco.tipoParentesco;
      Cliente.responsavel.cpf = this.Interesse.Responsavel.Cpf;
      Cliente.responsavel.enderecoIgualDoAluno = this.enderecoResponsavelIgualAluno;
      Cliente.responsavel.cep = this.enderecoResponsavelIgualAluno
        ? this.Interesse.Aluno.Endereco.Cep
        : this.Interesse.Responsavel.Endereco.Cep;
      Cliente.responsavel.logradouro = this.enderecoResponsavelIgualAluno
        ? this.Interesse.Aluno.Endereco.Logradouro
        : this.Interesse.Responsavel.Endereco.Logradouro;
      Cliente.responsavel.numeroLogradouro = this.enderecoResponsavelIgualAluno
        ? this.Interesse.Aluno.Endereco.Numero
        : this.Interesse.Responsavel.Endereco.Numero;
      Cliente.responsavel.complemento = this.enderecoResponsavelIgualAluno
        ? this.Interesse.Aluno.Endereco.Complemento
        : this.Interesse.Responsavel.Endereco.Complemento;
      Cliente.responsavel.bairro.descricao = this.enderecoResponsavelIgualAluno
        ? this.Interesse.Aluno.Endereco.Bairro
        : this.Interesse.Responsavel.Endereco.Bairro;
      Cliente.responsavel.cidade.descricao = this.enderecoResponsavelIgualAluno
        ? this.Interesse.Aluno.Endereco.Cidade
        : this.Interesse.Responsavel.Endereco.Cidade;
      Cliente.responsavel.uf = this.enderecoResponsavelIgualAluno
        ? this.Interesse.Aluno.Endereco.Estado
        : this.Interesse.Responsavel.Endereco.Estado;
      Cliente.responsavel.contatos[0].tipoContato = this.identificarTipoTelefone(this.Interesse.Responsavel.Telefone);
      Cliente.responsavel.contatos[0].contato = this.Interesse.Responsavel.Telefone;
      Cliente.responsavel.contatos[1].tipoContato = 4;
      Cliente.responsavel.contatos[1].contato = this.Interesse.Responsavel.Email;

      Cliente.interesse.midia.codigo = this.Interesse.Midia.codigo;
      Cliente.interesse.midia.descricao = this.Interesse.Midia.descricao;

      if (this.Interesse.EscolaAnterior)
      {        
        Cliente.interesse.escolaAnterior.codigo =
          this.Interesse.EscolaAnterior.codigo == null
          ? 0
          : this.Interesse.EscolaAnterior.codigo;
        Cliente.interesse.escolaAnterior.descricao =
          this.Interesse.EscolaAnterior.descricao == null && this.Interesse.EscolaAnterior.codigo == null
          ? this.Interesse.EscolaAnterior
          : this.Interesse.EscolaAnterior.descricao;
      }

      Cliente.interesse.unidade= this.Interesse.OpcoesInteresse.Unidade;
      Cliente.interesse.periodo = this.Interesse.OpcoesInteresse.Periodo;
      Cliente.interesse.curso = this.Interesse.OpcoesInteresse.Curso;
      Cliente.interesse.serie.codigo = this.Interesse.OpcoesInteresse.Serie.codigo;
      Cliente.interesse.serie.descricao = this.Interesse.OpcoesInteresse.Serie.descricao;
      Cliente.interesse.turno = this.Interesse.OpcoesInteresse.Turno;

      return Cliente;
    },
    identificarTipoTelefone(telefone) {
      if (telefone.length <= 14) return 1;
      return 2;
    },
    enderecoObrigatorio(endereco) {      
      return (endereco.Cep.length > 0 ||
        endereco.Logradouro.length > 0 ||
        endereco.Numero.length > 0 ||
        endereco.Bairro.length > 0 ||
        endereco.Cidade.length > 0 ||
        endereco.Estado.length > 0)
    },
  }
})